export default "__VITE_PUBLIC_ASSET__4f89ffe3__"